

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETCUSTOMERBYID
// GETCUSTOMERBYID
const GETCUSTOMERBYID= createAsyncThunk(
  "getCustomerById/getCustomerById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCustomerByIdSlice = createSlice({
  name: "getCustomerByIdSlice",
  initialState: {
    getCustomerById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCustomerById: (state) => {
        state.getCustomerById.loading = false
        state.getCustomerById.error = false
        state.getCustomerById.data = []
        state.getCustomerById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCUSTOMERBYID.fulfilled, (state, action) => {
      state.getCustomerById = {
        ...state.getCustomerById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERBYID.pending, (state, action) => {
      state.getCustomerById = {
        ...state.getCustomerById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERBYID.rejected, (state, action) => {
      state.getCustomerById = {
        ...state.getCustomerById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCustomerByIdAction = {
    GETCUSTOMERBYID,
};

export { getCustomerByIdAction };
export default getCustomerByIdSlice.reducer;
export const {setInitialStateOfgetCustomerById} = getCustomerByIdSlice.actions